import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function useMetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s?.parentNode) {
      s.parentNode.insertBefore(t, s);
    }
    window.fbq('init', '1402851287884688');
    window.fbq('track', 'PageView');
  }, []);
}
export function trackAddToCart() {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_name: 'Is This God or My Fear? — Relationship Edition',
      content_type: 'product',
      value: 17.95,
      currency: 'USD'
    });
  }
}